import {
    useNotifyError as libUseNotifyError,
    type ErrorMessageMap,
} from "@for-it/web-lib";
import { type DomainErrorNames, type DomainErrors } from "app-domain";

export const errorMessages = {
    EmailAlreadyValidatedError: "This email has already been validated.",
    EmailInUseError: "This email is already in use.",
    InvalidCredentialsError: "Credenciales inválidas.",
    InvalidEmailValidationTokenError: "Invalid email validation token.",
    NotFoundError: "Not found.",
    RateLimitError: "Rate limit exceeded.",
    UnexpectedError: "An unexpected error occurred.",
    RefreshTokenExpiredError: "Refresh token expired.",
    RefreshTokenInvalidError: "Refresh token invalid.",
    InvalidFileTypeError: "Invalid file type.",
    CompanyNotFoundError: "Empresa no ha sido encontrada",
    PublicationNotFoundError: "Publicación no encontrada",
    CertificationUserNotFoundError: "Certificación del usuario no encontrada",
    AccessTokenExpiredError: "Access token expired.",
    ApplicantNotFoundError: "Applicant not found.",
    DniInUseError: "El DNI ya está en uso.",
    TagAlreadyExistsError: "Tag already exists.",
    CertificationNotFoundError: "Certificación no encontrada",
    PasswordRepeatError: "Passwords do not match.",
    CertificationAlreadyExistsError: "Certification already exists.",
    ApplicationToJobAlreadyExists: "Application to job already exists",
    AccountDisabledError: "Tu cuenta fue deshabilitada. ¿Quieres reactivarla?",
} as const satisfies ErrorMessageMap<DomainErrorNames>;

export const useNotifyError = libUseNotifyError<DomainErrors>;
